
export default {
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
  },
};
